/**
 * integrate veeValidate
 */
import { pickBy, sortBy, keys, chain, filter, forEach } from 'lodash'

export default {
  methods: {
    $doValidate (refObserver, { showMsg, doScrollTo = true } = {}) {
      if (!refObserver) return
      let obs = this.$refs[refObserver]
      if (Array.isArray(obs)) {
        // 修正若在v-for時，ref結果會成為array
        let [first] = obs
        obs = first
      }

      if (obs) {
        return obs.validate().then(isValid => {
          if (!isValid) {
            let id = this._resolveId(obs)
            if (id) {
              doScrollTo && obs.$scrollTo(id, true) // scroll to and focus
              let errors = this.$errorMsgHandler(obs.errors)
              showMsg && this.$alert(errors) // show invalid msg
            } else {
              this.$nextTick(() => {
                setTimeout(() => {
                  id = this._resolveId(obs)
                  doScrollTo && obs.$scrollTo(id, true) // scroll to and focus
                  let errors = this.$errorMsgHandler(obs.errors)
                  showMsg && this.$alert(errors) // show invalid msg
                }, 1000)
              })
            }
          }
          return isValid
        })
      }
    },

    /**
     * recursive rest observer
     * @param {string or object} obs
     */
    $reset (obs) {
      if (!obs) return
      if (this.$bi.isString(obs)) {
        obs = this.$refs[obs]
      }
      if (Array.isArray(obs)) {
        // 修正若在v-for時，ref結果會成為array
        let [first] = obs
        obs = first
      }
      if (obs) {
        obs.reset()
        if (obs.observers.length > 0) {
          forEach(obs.observers, o => {
            obs.$reset(o)
          })
        }
      }
    },

    /**
     * @description get error count
     * @param {pbserver} obs
     */
    $validateNum (refObserver) {
      if (!refObserver) return 0
      let obs = this.$refs[refObserver]
      if (Array.isArray(obs)) {
        // 修正若在v-for時，ref結果會成為array
        let [first] = obs
        obs = first
      }

      if (obs) {
        const errorIds = this._allErrorObs(obs)
        return errorIds.length
      }
      return 0
    },

    /**
     * @description recursive find id
     * @param {pbserver} obs
     */
    _resolveId (obs) {
      const errorIds = this._allErrorObs(obs)
      let tops = []
      forEach(errorIds, id => {
        const el = document.querySelector(`#${id}`)
        const { top } = el.getBoundingClientRect()
        tops.push({ id, top })
      })
      tops = sortBy(tops, ['top'])
      const [first = {}] = tops
      // console.log({ tops, first, id: first.id })
      return first.id
    },
    _allErrorObs (obs, r = []) {
      let errorIds = pickBy(obs.errors, v => v.length > 0)
      errorIds = keys(errorIds)
      // console.log({ errorIds })
      forEach(errorIds, id => {
        const el = obs.$el.querySelector(`#${id}`)
        if (el) {
          r.push(id)
        } else {
          let o = filter(obs.observers, o => o.id === id)
          if (o.length > 0) {
            [o] = o
            return this._allErrorObs(o, r)
          }
        }
      })
      return r
    },

    $errorMsgHandler (errors) {
      return chain(errors)
        .values()
        .flatten()
        .uniq()
        .value()
    }
  }
}
